import React, { useState } from 'react';
import styled from 'styled-components';
import { WeeklyUserCountPayload } from '../../../api/serviceAnalytics/userAnalysis/type';
import Header from '../../Molecule/Card/CardHeader';
import Title from '../../Molecule/Card/CardTitle/ChartTitle';
import HeatmapChart from '../../Molecule/Chart/HeatmapChart';
import HeatmapLegend from '../../Molecule/Chart/Legend/HeatmapLegend';
import Spinner from '../../Molecule/Spinner';

const Component = styled.div`
  width: 100%;
  height: 497px;
  display: flex;
  flex-direction: column;
  background-color: white;
  padding: 24px 24px 40px 24px;
  border-radius: 16px;
`;

const Body = styled.div`
  flex: 1;
  width: 100%;
  margin-top: 40px;
`;

interface HeatmapChartCardProps {
  Data: WeeklyUserCountPayload | null;
  label1: string;
  label2: string;
  totalLabel: string;
  loading: boolean;
}

const HeatmapChartCard = ({
  Data,
  label1,
  label2,
  totalLabel,
  loading,
}: HeatmapChartCardProps) => {
  const [max, setHeatmapMax] = useState(0);
  const [min, setHeatmapMin] = useState(0);
  return (
    <Component>
      <Header>
        <Title title="시간대별 그래프" />
        <HeatmapLegend min={min} max={max} />
      </Header>
      <Body>
        {loading ? (
          <Spinner />
        ) : (
          <HeatmapChart
            Data={Data}
            label1={label1}
            label2={label2}
            totalLabel={totalLabel}
            setHeatmapMax={setHeatmapMax}
            setHeatmapMin={setHeatmapMin}
          />
        )}
      </Body>
    </Component>
  );
};

export default HeatmapChartCard;
